import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

export const venueCategories = [['cafe', 'Cafés', '☕'], ['restaurant', "מסעדות", '♨'], ['bar', "ברים", '◒'], ['shows', "מוזיקה ותיאטרון", '♫'], ['outdoors', "פארקים", '✿']];

export default function VenueCard({ venue, token, cityName, onChoose }) {
  const [photo, setPhoto] = useState(venue.image_url || '');
  const [failed, setFailed] = useState(false);
  const [visible, setVisible] = useState(false);
  const frame = useRef(null);
  useEffect(() => {
    if (!window.IntersectionObserver) { setVisible(true); return undefined; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: '100px' });
    if (frame.current) observer.observe(frame.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    let active = true;
    setPhoto(venue.image_url || '');
    setFailed(false);
    if (visible && venue.photo_token) {
      axios.post(`${API_BASE_URL}/venue_photo`, { token: venue.photo_token },
        { headers: { Authorization: `Bearer ${token || localStorage.getItem('token')}` } })
        .then(({ data }) => { if (active) setPhoto(data.url); })
        .catch(() => { if (active) setFailed(true); });
    }
    return () => { active = false; };
  }, [visible, venue.image_url, venue.photo_token, token]);
  const category = venueCategories.find(([id]) => id === venue.category) || venueCategories[0];
  const destination = `${venue.name}, ${venue.address || cityName || ''}`;
  const directions = venue.directions_url?.startsWith('https://www.google.com/maps/dir/')
    ? venue.directions_url : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
  return <article className={`venue-card ${venue.sponsored ? 'venue-card-sponsored' : ''}`} aria-label={venue.name}>
    <div className={`venue-cover venue-cover-${category[0]}`} ref={frame}>
      {photo && !failed ? <img src={photo} alt={venue.name} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
        : <div className="venue-photo-placeholder"><span aria-hidden="true">{category[2]}</span><small>{venue.photo_token && !failed ? "טוענים תמונה…" : "התמונה אינה זמינה"}</small></div>}
      <span className="venue-category-label">{category[1]}</span>
      {venue.sponsored && <span className="venue-sponsored-label">ממומן</span>}
    </div>
    <div className="venue-card-body">
      {(venue.photo_attributions?.length > 0 || venue.image_credit) && <div className="venue-photo-credit">
        {venue.image_credit || venue.photo_attributions.map((author, index) => author.url
          ? <a key={index} href={author.url} target="_blank" rel="noopener noreferrer">{author.name}</a> : <span key={index}>{author.name}</span>)}
        {venue.photo_source_url && <a href={venue.photo_source_url} target="_blank" rel="noopener noreferrer">מקור התמונה</a>}
        {venue.image_license_url && <a href={venue.image_license_url} target="_blank" rel="noopener noreferrer">{venue.image_license}</a>}
      </div>}
      <div className="venue-card-heading"><h4>{venue.name}</h4>{typeof venue.rating === 'number' && <a className="venue-rating" href={venue.map_url} target="_blank" rel="noopener noreferrer" aria-label={`${venue.rating} מתוך 5, ${venue.review_count || 0} ביקורות ב־Google`}><span aria-hidden="true">★</span> {venue.rating.toFixed(1)} <small>({venue.review_count || 0})</small></a>}</div>
      <p className="venue-address">{venue.address || cityName}{typeof venue.distance_km === 'number' && <span> · {venue.distance_km} ק״מ מהמרכז</span>}</p>
      {venue.description && <p className="venue-description">{venue.description}</p>}
      {venue.sponsored && <p className="venue-sponsor-name">פרסום ממומן מטעם {venue.sponsor_name}</p>}
      <div className="venue-hours-line">
        {typeof venue.open_now === 'boolean' && <span className={venue.open_now ? 'venue-open' : 'venue-closed'}>{venue.open_now ? "פתוח עכשיו" : "סגור עכשיו"}</span>}
        {venue.hours?.length ? <details className="venue-hours"><summary>שעות פתיחה</summary>{venue.hours.map(day => <p key={day}>{day}</p>)}</details>
          : <small>{venue.opening_hours ? `שעות רשומות: ${venue.opening_hours}` : "בדקו שעות פתיחה לפני שיוצאים"}</small>}
      </div>
      <div className="venue-card-actions"><button type="button" onClick={() => onChoose(`${venue.name}, ${venue.address || cityName}`.slice(0, 100))}>בחירת המקום הזה <span aria-hidden="true">↗</span></button>
        <a href={directions} target="_blank" rel="noopener noreferrer" aria-label={`הוראות הגעה אל ${venue.name} במפות Google`}>מפות Google ↗</a></div>
      {venue.source === 'google' && <div className="venue-google-source"><a href={venue.map_url} translate="no" target="_blank" rel="noopener noreferrer">מפות Google</a>{venue.attributions?.map((item, index) => <a key={index} href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a>)}</div>}
    </div>
  </article>;
}
